import React, { useState, useRef, useEffect } from "react";
import "./SelectTag.css";

function SelectTag({value, options, toSkip, width, dropdownWidth, onChange }) {
    
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    setSelected(value)
  } , [value])
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    if (onChange) {
      onChange(option);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="select-tag custom-select myprofile-general-value" ref={dropdownRef}>
      <div className="select-box" style={{ width : "100%"}} onClick={toggleDropdown}>
        {selected.label}
        <span className="arrow">▼</span>
      </div>
      {isOpen && (
        <div className="dropdown" style={{ width: dropdownWidth }}>
          {options
            .filter((item) => item.label !== toSkip)
            .map((option, index) => (
              <div key={index} className={`dropdown-item ${option.label == selected.label && "active"}`} onClick={() => handleSelect(option)}>
                {option.label}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default SelectTag;
